// extracted by mini-css-extract-plugin
export default {"halfWidthCardwrap":"src-pages-More-index-union_halfWidthCardwrap--jfyUK","halfWidthCard":"src-pages-More-index-union_halfWidthCard--CYOZt"};